import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TagInputModule } from "ngx-chips";
import { CommonTLFModule } from '../../common/common.module';
import { FormAppelloComponent } from './form-appello/form-appello.component';
import { FormAppelloViewComponent } from "./form-appello/view/form-appello-view.component";
import { FormCoterziComponent } from './form-coterzi/form-coterzi.component';
import { FormCoterziViewComponent } from "./form-coterzi/view/form-coterzi-view.component";
import { FormImmobiliareComponent } from './form-immobiliare/form-immobiliare.component';
import { FormImmobiliareViewComponent } from "./form-immobiliare/view/form-immobiliare-view.component";
import { FormMediazioneComponent } from './form-mediazione/form-mediazione.component';
import { FormMediazioneViewComponent } from "./form-mediazione/view/form-mediazione-view.component";
import { FormMobiliareComponent } from './form-mobiliare/form-mobiliare.component';
import { FormMobiliareViewComponent } from "./form-mobiliare/view/form-mobiliare-view.component";
import { FormOrdinarioComponent } from './form-ordinario/form-ordinario.component';
import { FormOrdinarioViewComponent } from "./form-ordinario/view/form-ordinario-view.component";
import { FormParereComponent } from './form-parere/form-parere.component';
import { FormParereViewComponent } from "./form-parere/view/form-parere-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from './form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component';
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "./form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import { FormRicorsoCassazioneComponent } from './form-ricorso-cassazione/form-ricorso-cassazione.component';
import {
  FormRicorsoCassazioneViewComponent
} from "./form-ricorso-cassazione/view/form-ricorso-cassazione-view.component";
import { DynamicComponentService } from "./services/dynamic-component.service";
import { FormGenericoComponent } from './form-generico/form-generico.component';
import { FormGenericoViewComponent } from './form-generico/view/form-generico-view.component';

@NgModule({
    imports: [CommonTLFModule, CommonModule, RouterModule, NgbModule, FormsModule, ReactiveFormsModule, TagInputModule, NgSelectModule],
    declarations: [
        FormAppelloComponent,
        FormAppelloViewComponent,
        FormCoterziComponent,
        FormCoterziViewComponent,
        FormImmobiliareComponent,
        FormImmobiliareViewComponent,
        FormMediazioneComponent,
        FormMediazioneViewComponent,
        FormMobiliareComponent,
        FormMobiliareViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormParereComponent,
        FormParereViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent,
        FormRicorsoCassazioneComponent,
        FormRicorsoCassazioneViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
    ],
    providers: [DynamicComponentService],
    exports: [
        FormAppelloComponent,
        FormAppelloViewComponent,
        FormCoterziComponent,
        FormCoterziViewComponent,
        FormImmobiliareComponent,
        FormImmobiliareViewComponent,
        FormMediazioneComponent,
        FormMediazioneViewComponent,
        FormMobiliareComponent,
        FormMobiliareViewComponent,
        FormOrdinarioComponent,
        FormOrdinarioViewComponent,
        FormParereComponent,
        FormParereViewComponent,
        FormRecuperoCreditiStragiudizialeComponent,
        FormRecuperoCreditiStragiudizialeViewComponent,
        FormRicorsoCassazioneComponent,
        FormRicorsoCassazioneViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
    ]
})
export class FascicoloFormSharedModule {

}
